// extracted by mini-css-extract-plugin
export default {"product":"Product_product__Xdt5o","img":"Product_img__PiCwj","option":"Product_option__iD-Cm"};